<div class="input-group">
  <label
    *ngIf="file || document?.id"
    ngbTooltip="Consulter"
    placement="top"
    class="input-group-prepend mb-0 btn btn-primary cursor-pointer"
    (click)="consultFile()"
  >
    <fa-icon icon="eye"></fa-icon>
  </label>
  <input
    type="text"
    class="form-control"
    [(ngModel)]="name"
    [class.is-invalid]="invalid"
    [class.bg-white]="!disabled"
    [disabled]="disabled"
    [attr.disabled]="true"
  />
  <label *ngIf="!disabled" class="input-group-append mb-0 btn btn-primary cursor-pointer rounded-end" ngbTooltip="Upload" placement="top">
    <fa-icon icon="upload"></fa-icon>
    <input
      (change)="onFileChange($event?.target?.files)"
      type="file"
      onclick="this.value = null"
      [accept]="accept || '*'"
      style="display: none"
      [disabled]="disabled"
    />
  </label>
</div>
